/** Canonical public list prices. Keep in sync with backend `core.plans` / `core.seats`. */

export const PLAN_PRICE = {
	basic: 25,
	pro: 45,
};

export const PRO_INCLUDED_SEATS = 10;
export const EXTRA_SEAT_MONTHLY = 3;
